import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { FileText, Download } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SeasonsDownload = ({ user }) => {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSeasons();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await axios.get(`${API}/seasons`);
      setSeasons(response.data);
    } catch (error) {
      console.error('Error fetching seasons:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePricelistClick = (season) => {
    if (!user) {
      toast.error('Debes iniciar sesión para acceder a las tarifas');
      navigate('/login');
      return;
    }

    // If user is logged in, download the pricelist
    window.open(season.pricelist_url, '_blank');
  };

  const handleCatalogClick = (season) => {
    // Catalogs are public, open directly
    window.open(season.catalog_url, '_blank');
  };

  if (loading) {
    return null;
  }

  if (seasons.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200">
      <div className="mb-6">
        <h3 className="text-2xl font-bold text-black mb-2">📚 Catálogos y Tarifas</h3>
        <p className="text-gray-600">
          Descarga catálogos y tarifas por temporada
        </p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {seasons.map((season) => (
          <div
            key={season.id}
            className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-500 transition-colors"
          >
            <div className="mb-3">
              <h4 className="text-lg font-bold text-black">{season.name}</h4>
              <p className="text-sm text-gray-600">{season.display_name}</p>
            </div>
            
            <div className="space-y-2">
              <Button
                onClick={() => handleCatalogClick(season)}
                size="sm"
                variant="outline"
                className="w-full justify-start"
              >
                <FileText className="w-4 h-4 mr-2" />
                📕 Catálogo
              </Button>
              
              <Button
                onClick={() => handlePricelistClick(season)}
                size="sm"
                variant="outline"
                className="w-full justify-start"
              >
                <Download className="w-4 h-4 mr-2" />
                {user ? '📊 Tarifa' : '🔒 Tarifa (Login)'}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeasonsDownload;
